import { Fancybox } from "@fancyapps/ui";

import Swiper, { Navigation, Thumbs } from "swiper"
Swiper.use([Navigation, Thumbs])

export default new (class GalleryCarousel {
    constructor() {
        this.sliderContainerSelectorMain = "_carousel-gallery"
        this.sliderContainerSelectorSub = "_carousel-gallery-sub"
        this.sliderNextSelector = "_carousel-gallery-next"
        this.sliderPrevSelector = "_carousel-gallery-prev"
        this.sliderGalleryPreview = '[data-fancybox="gallery"]:not(.swiper-slide-duplicate)'
        this.sliderGalleryProject = '_project-gallery'
        this.handler()
    }

    handler() {
        const sliderSub = document.querySelector(`.${this.sliderContainerSelectorSub}`)
        const sliderMain = document.querySelector(`.${this.sliderContainerSelectorMain}`)

        if (!sliderSub) return
        if (!sliderMain) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
            this.initFancybox()
        })
    }

    init() {
        let sliderSub_slidesPerView_300 = 3;
        let sliderSub_slidesPerView_1200 = 4;

        let sliderSub_spaceBetween_300 = 6;
        let sliderSub_spaceBetween_1200 = 6;

        let sliderSub_direction_300 = "horizontal";
        let sliderSub_direction_768 = "horizontal";
        let sliderSub_direction_1200 = "horizontal";

        if(document.querySelector(`.${this.sliderGalleryProject} .${this.sliderContainerSelectorSub}`)) {
            sliderSub_slidesPerView_300 = 5;
            sliderSub_slidesPerView_1200 = 5;

            sliderSub_spaceBetween_300 = 4;
            sliderSub_spaceBetween_1200 = 8;

            sliderSub_direction_300 = "horizontal";
            sliderSub_direction_768 = "vertical";
            sliderSub_direction_1200 = "horizontal";
        }

        this.SubCarousel = new Swiper(`.${this.sliderContainerSelectorSub}`, {
            slidesPerView: sliderSub_slidesPerView_300,
            spaceBetween: sliderSub_spaceBetween_300,
            direction: sliderSub_direction_300,
            freeMode: true,
            watchSlidesProgress: true,
            centerInsufficientSlides: true,
            breakpoints: {
                300: {
                    slidesPerView: sliderSub_slidesPerView_300,
                    spaceBetween: sliderSub_spaceBetween_300,
                    direction: sliderSub_direction_300,
                },
                768: {
                    direction: sliderSub_direction_768,
                },
                1200: {
                    slidesPerView: sliderSub_slidesPerView_1200,
                    spaceBetween: sliderSub_spaceBetween_1200,
                    direction: sliderSub_direction_1200,
                },
            },
        })
        this.MainCarousel = new Swiper(`.${this.sliderContainerSelectorMain}`, {
            slidesPerView: 1,
            spaceBetween: 30,
            thumbs: {
                swiper: this.SubCarousel,
            },
            navigation: {
                nextEl: `.${this.sliderNextSelector}`,
                prevEl: `.${this.sliderPrevSelector}`,
            },
        })
    }

    initFancybox() {
        Fancybox.bind(`${this.sliderGalleryPreview}`, {
            groupAll: true,
            infinite: false,
            placeFocusBack: true,
            animated: false,
            closeButton: "outside",
            mainClass: "fancybox-custom",
            showClass: false,
            hideClass: false,
            template : {
                main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
            },
            on: {
                ready: (fancybox) => {
                    if(document.querySelector('.can-zoom_in')) {
                        document.querySelectorAll('.can-zoom_in').forEach(element => {
                            element.classList.remove(can-zoom_in);
                        });
                    }
                    if(fancybox.items.length > 1) {
                        document.querySelector('.carousel__button.is-next').innerHTML = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="30" transform="matrix(1 0 0 -1 30 30)" fill="#253642" fill-opacity="0.6"/><path d="M26 19.3334L36.6667 30L26 40.6667" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>'
                        document.querySelector('.carousel__button.is-prev').innerHTML = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="30" transform="matrix(-1 0 0 1 30 30)" fill="#253642" fill-opacity="0.6"/><path d="M34 19.3334L23.3333 30L34 40.6667" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>'
                    }
                    document.querySelector('.fancybox__button--close').innerHTML = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27 14.41L25.59 13L20 18.59L14.41 13L13 14.41L18.59 20L13 25.59L14.41 27L20 21.41L25.59 27L27 25.59L21.41 20L27 14.41Z" fill="#253642"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#253642"/></svg>'
                },
            }
        });
    }
})()
